import ChangePasswordPage from "../../components/auth/change-password"

const ChangePassword = () => {
  return (
    <div><ChangePasswordPage /></div>
  )
}

export default ChangePassword